module.exports = __webpack_public_path__ + "img/molinks.1224de24.jpg";